import { render, staticRenderFns } from "./SzDropdown.vue?vue&type=template&id=0163c77c&scoped=true"
import script from "./SzDropdown.vue?vue&type=script&lang=js"
export * from "./SzDropdown.vue?vue&type=script&lang=js"
import style0 from "./SzDropdown.vue?vue&type=style&index=0&id=0163c77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163c77c",
  null
  
)

export default component.exports